import { Button, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeleteModal = ({ isOpen, onClose, title, onConfirm, isLoading }: DeleteModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <Stack
        gap={2}
        pt={4}
        pb={2}
        px={3}
      >
        <Typography
          variant="h5"
          sx={{
            '&.MuiTypography-root': {
              fontSize: 20,
            },
          }}
        >
          {title}
        </Typography>
      </Stack>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          loading={isLoading}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
